// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { FilesInstance } from "./helpers/filesInstanceHelpers";
import { createFilesInstance } from "./helpers/filesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, FilesInstance>({
	name: "Files",
	createBase: createBaseNotary,
	createInstance: createFilesInstance,
});

export function getFilesInstance(): FilesInstance {
	return factory.getInstance();
}
